<template>
	<div class="bg">
		<!-- 搜索栏 -->
		<div class="top_search_part main_top_search">
			<div class="search_box">
				<div class="search_item">
					<div class="block">
						
						<el-date-picker
						      v-model="monthVal"
						      type="date"
						      placeholder="选择日期"
						      format="yyyy 年 MM 月 dd 日"
						      value-format="yyyy-MM-dd" 
									@change="monthChange">
									
									<!-- @change="monthChange" -->
						    </el-date-picker>
						</div>
				</div>
				<div class="search_item">
					<el-select v-model="cityVal" @change="cityChange">
						<el-option label="全部" value=""></el-option>
						<el-option :label="$t('message.tokyoOffice')" value="東京"></el-option>
						<el-option :label="$t('message.osakaOffice')" value="大阪"></el-option>
						 <el-option  :label="$t('message.KWS1Office')" value="藤井寺"></el-option>
						 <el-option  :label="$t('message.SWH7Office')" value="市川"></el-option>
					</el-select>
				</div>
				<div class="search_btn" @click="searchOrder">{{ $t('message.searchBtnText') }}</div>
			</div>
		</div>
		<!-- 表格 -->
		<div class="content">
			<div class="tableBox">
				<el-table
					id="orderList"
					:data="orderList"
					style="width: 100%"
					height="100%"
					stripe
					size="small"
					header-cell-class-name="tableHeader"
					cell-class-name="tableBodyer"
					@sort-change="sortChange"
					border
				>
					<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="60" fixed="left"></el-table-column>

					<el-table-column :label="$t('message.containerCreater')" prop="GUDING1" width="120" fixed="left">
						<template slot-scope="scope">
							<span v-if="isAdmin" @click="showHeaderDialog(scope.row.ID)">{{ scope.row.GUDING1 }}</span>
							<span v-else>{{ scope.row.GUDING1 }}</span>
						</template>
					</el-table-column>

					<el-table-column :label="$t('message.deleteTime')" prop="DADATE" width="160" fixed="left"></el-table-column>
					<el-table-column :label="$t('message.deleteAddress')" prop="CITY" width="160" fixed="left"></el-table-column>

					<el-table-column :label="$t('message.containerOrderCustomerID')" prop="customerId" width="160" fixed="left"></el-table-column>
					<el-table-column :label="$t('message.customerDedicatedNum')" prop="KRZYBH" width="120" fixed="left"></el-table-column>
					<!-- <el-table-column :label="$t('message.containerOrderCustomer')" prop="KEREN" width="160" fixed="left"></el-table-column> -->
					<el-table-column :label="$t('message.placeOfDelivery')" prop="placeOfDelivery" width="160" fixed="left"></el-table-column>
					<el-table-column :label="$t('message.deliveryDate')" prop="DDDATE" width="130"></el-table-column>
					<el-table-column :label="$t('message.containerStripping')" prop="DATIME" width="140"></el-table-column>
					<el-table-column :label="$t('message.containerGoodsModel')" width="140" sortable="custom" prop="JZXSIZE">
						<template slot-scope="scope">
							<span
								:class="{
									color1: scope.row.JZXSIZE === '40GP/HQ',
									color2: scope.row.JZXSIZE === '20GP/HQ',
									color3: scope.row.JZXSIZE === 'CFS',
									color4: scope.row.JZXSIZE === 'KIX',
									color5: scope.row.JZXSIZE === 'NRT',
									color6: scope.row.JZXSIZE === 'HND'
								}"
							>
								{{ scope.row.JZXSIZE }}
							</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('message.containerOrderNumber')" prop="JZXNUM" min-width="150"></el-table-column>
					<el-table-column :label="$t('message.trailerArrangement')" min-width="150">
						<template slot-scope="scope">
							<span style="white-space:pre-line;">{{ scope.row.TCAP }} {{ scope.row.TCAPDZ }}</span>
						</template>
					</el-table-column>

					<el-table-column :label="$t('message.inspection')" prop="GPJC" width="110"></el-table-column>
					<el-table-column :label="$t('message.containerOrderNum')" prop="SHULIANG" width="150"></el-table-column>
					<el-table-column :label="$t('message.containerOrderWeight')" prop="ZHONGLIANG" width="150"></el-table-column>
					<el-table-column :label="$t('message.containerOrderVolume')" prop="TIJI" width="150"></el-table-column>
					<el-table-column :label="$t('message.litijin')" prop="LITIJIN" width="120"></el-table-column>
					<el-table-column :label="$t('message.containerOrderRemark')" prop="REMARK" width="120" show-overflow-tooltip resizable></el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChange"
				@current-change="currentChange"
				:current-page="page_no"
				:page-sizes="pageSizes"
				:page-size="page_size"
				layout="total, sizes, prev, pager, next"
				:total="totalSize"
				class="tablePage"
			></el-pagination>
		</div>
		<!-- 表格 -->
	</div>
</template>

<script>
import { noEnterContain, getOrderRecycleBin, exportContainerOrder, HTTPS } from '@/api/getData.js';

export default {
	name: 'orderRecycleBin',
	data() {
		return {
			isAdmin: false,
			monthVal: '', // 月份选择
			cityVal: '',
			orderList: [],
			specialIdentity: '',
			page_no: 1,
			page_size: 50,
			pageSizes: [20, 50, 100, 200, 500, 1000],
			totalSize: 0
		};
	},
	created() {
		this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin');
		this.specialIdentity = this.$store.state.JHSS.personalUserid !== 'administrator' ? this.$store.state.JHSS.personalSpecial : 'administrator';
		// let param = this.$store.state.JHSS_containerInfo_param;
		// if (param.DADATE) {
		// 	this.monthVal = param.DADATE;
		// }
		// if (param.CITY) this.cityVal = param.CITY;
		this.getOrderRecycleBin();
	},
	methods: {
		// 当前月份
		// getTime() {
		// 	let date = new Date();
		// 	let year = date.getFullYear();
		// 	let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
		// 	let obj = {
		// 		year: year,
		// 		month: year + '-' + month
		// 	};
		// 	return obj;
		// },
		// 日期选择
		monthChange(val) {
			this.monthVal = val;
			// this.getOrderRecycleBin();
		},
		// 城市选择
		cityChange(val) {
			// this.$store.commit('setCityVal', val)
			this.cityVal = val;
			// this.getOrderRecycleBin();
		},
		// 查询集装箱订单
		async getOrderRecycleBin() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let param = { DADATE: this.monthVal, CITY: this.cityVal,PAGE: this.page_no, TYPE: this.page_size, ADDUSERID: this.$store.state.JHSS.personalUserid };
			if (this.prop) param.ORDERNAME = this.prop;
			param.DOA = this.order;
			console.log(param);
			let res = await getOrderRecycleBin(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			// console.log(res.data)
			this.totalSize = res.data.num;
			let _this = this;
			let index = 0;
			this.orderList = res.data.dt.map(item => {
				// console.log('item', item);
				item.index = ++index;
				item.arrivalTime = item.DATIME + ' ' + item.DADATE;
				let city = !item.THCITY ? '' : item.THCITY;
				let address = !item.THDIZHI ? '' : item.THDIZHI;
				item.placeOfDelivery = city + ' ' + address;
				// item.containerTrailerCity=!item.TCAP ? '' : item.TCAP;
				// trailerLocation=!item.TCAPDZ ? '' : item.TCAPDZ;
				// let city = !item.THCITY ? '' : item.THCITY;
				// let address = !item.THDIZHI ? '' : item.THDIZHI;

				let date = !item.THDATE ? '' : item.THDATE;
				let assign = !item.DDDATE ? '' : item.DDDATE;
				item.deliveryDate = date + ' ' + assign;
				item.addTime = item.ADDTIME.replace(/T/g, ' ');
				item.customerId = !item.CUSTOMERID ? '' : item.CUSTOMERID.split(',')[0];
				if (item.GUDING3 === null || item.GUDING3 === '') {
					item.goodsStatus = _this.$t('message.setGoodsStatus');
				} else if (item.GUDING3 === '0') {
					item.goodsStatus = _this.$t('message.notArrive');
				} else {
					item.goodsStatus = _this.$t('message.hasArrive');
				}
				if (item.GUDING4 === null || item.GUDING4 === '') {
					item.condition = _this.$t('message.setGoodsStatus');
				} else if (item.GUDING4 === '0') {
					item.condition = _this.$t('message.abnormalCondition');
					// + (!item.GUDING5 ? '' : ': ' + item.GUDING5)
				} else {
					item.condition = _this.$t('message.normalCondition');
				}
				return item;
			});
		},
		//搜索
		searchOrder() {
			this.getOrderRecycleBin();
		},
		sizeChange(val) {
			this.page_size = val;
			this.getOrderRecycleBin();
		},
		currentChange(val) {
			this.page_no = val;
			this.getOrderRecycleBin();
		},
		// 排序
		sortChange(obj) {
			// console.log(obj)
			// 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
			this.prop = null;
			if (obj.prop === 'arrivalTime') {
				this.prop = 'DADATE,DATIME';
			}
			if (obj.prop === 'JZXSIZE') {
				this.prop = 'JZXSIZE';
			}
			this.order = '';
			if (obj.order === 'descending') {
				this.order = 'DESC';
			}
			if (!obj.order) {
				this.prop = null;
			}
			this.getContainerOrder();
		}
	}
};
</script>

<style>
#orderRecycleBin {
	width: 100%;
	height: 100%;
}
.top_title {
	width: 100%;
	height: 86px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 40px 0 45px;
	background: #ffffff;
	box-shadow: 0 0 4px 0 rgba(203, 203, 203, 0.5);
	border-radius: 2px 0;
	font-size: 20px;
	color: #333333;
}
.noEnterContainersNum {
	flex-shrink: 0;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	font-size: 16px;
	color: #666666;
}
.main_top_search {
	/* height: 180px; */
	height: 126px;
	flex-wrap: wrap;
}
.main_top_search :first-child {
	flex-wrap: wrap;
	flex-shrink: 1;
}
.main_top_search :first-child .search_item,
.main_top_search :first-child .search_btn,
.main_top_search :first-child .add_btn {
	/* margin-bottom: 10px; */
	margin-top: 10px;
}

.color1 {
	color: #0048ff;
}
.color2 {
	color: #00cbc9;
}
.color3 {
	color: #ff8524;
}
.color4 {
	color: #00b7ff;
}
.color5 {
	color: #ffbb00;
}
.color6 {
	color: #9800ff;
}
</style>
